import { __assign } from "tslib";
import React from 'react';
import { DuperbrowseViewContext } from '../DuperbrowseViewContext';
import DuperbrowsePaddles from '../DuperbrowsePaddles';
import { IconSize } from '../../Icons/IconWrap';
import CloseIcon from '../../Icons/CloseBig';
import { getBasicBiDataForDuperItem } from '../redux/helpers';
import { BiEventType } from '../../biLogger/constants';
import PlainButtonOrLink from '../../Button/PlainButtonOrLink';
import s from './DuperbrowseLightBox.scss';
var DuperbrowseLightbox = function (_a) {
    var children = _a.children, duperbrowseItem = _a.duperbrowseItem, exitDuperbrowse = _a.exitDuperbrowse, parent = _a.parent;
    var _b, _c, _d;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['underlay'], onClick: exitDuperbrowse }),
        React.createElement(DuperbrowseViewContext.Provider, { value: "lightbox" },
            React.createElement("div", { className: s['lightbox'] }, children)),
        duperbrowseItem && (React.createElement(React.Fragment, null,
            React.createElement(DuperbrowsePaddles, { showBackTo: false, className: s['paddles'], paddleClassName: s['paddle'], iconClassName: s['paddle-icon'] }),
            React.createElement(PlainButtonOrLink, { className: s['close'], onClick: exitDuperbrowse, biData: __assign({ evid: BiEventType.BACK_TO_CLICK, link_url: (_b = parent) === null || _b === void 0 ? void 0 : _b.url, next_itemid: (_c = parent) === null || _c === void 0 ? void 0 : _c.itemId, next_typeid: (_d = parent) === null || _d === void 0 ? void 0 : _d.typeId }, (duperbrowseItem &&
                    getBasicBiDataForDuperItem(duperbrowseItem))) },
                React.createElement(CloseIcon, { className: s['close-icon'], disableDefaultColors: true, size: IconSize.MEDIUM }))))));
};
DuperbrowseLightbox.displayName = 'DuperbrowseLightbox';
export default DuperbrowseLightbox;
//# sourceMappingURL=DuperbrowseLightbox.js.map